// src/components/TestimonialCard/TestimonialCard.tsx
import React, { useState } from "react";
import { FaStar } from "react-icons/fa"; // This line is crucial
import { Testimonial } from "../../sections/Testimonials/testimonialData";

interface TestimonialCardProps {
  testimonial: Testimonial;
}

const TestimonialCard: React.FC<TestimonialCardProps> = ({ testimonial }) => {
  const [showFullText, setShowFullText] = useState<boolean>(false);

  const toggleShowFullText = () => {
    setShowFullText(!showFullText);
  };
  console.log(testimonial);
  const charLimit = 200;
  const isTruncated = testimonial.content.length > charLimit;
  const displayText = showFullText
    ? testimonial.content
    : `${testimonial.content.substring(0, charLimit)}${
        isTruncated ? "..." : ""
      }`;

  return (
    <div
      className="
      single-testimonial bg-white p-8 rounded-lg shadow-md
      flex flex-col h-full border border-gray-100 hover:shadow-lg transition-shadow duration-300
      " // Ensure no max-w-sm or explicit width here
    >
      <div className="rating-box mb-4">
        <ul className="flex justify-center text-yellow-400">
          <div className="flex justify-center mb-4 text-yellow-400 text-xl">
            {"★".repeat(testimonial.rating)}
          </div>
        </ul>
      </div>
      <div className="testimonial-content flex-grow text-center overflow-hidden">
        <p className="text-text-gray-medium leading-relaxed mb-4 text-base">
          {displayText}
          {isTruncated && (
            <button
              className="services-link readmore text-accent-blue underline cursor-pointer ml-1 hover:text-primary-blue focus:outline-none"
              onClick={toggleShowFullText}
            >
              {showFullText ? "Read Less" : "Read More"}
            </button>
          )}
        </p>
      </div>
      <div className="avatar mt-4 flex flex-col items-center">
        {testimonial.avatarSrc ? (
          <img
            src={testimonial.avatarSrc}
            alt={`${testimonial.name} avatar`}
            className="w-20 h-20 rounded-full object-cover border-2 border-primary-blue shadow-md"
            onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src =
                "https://placehold.co/80x80/cccccc/333333?text=User";
            }}
          />
        ) : (
          <div className="w-20 h-20 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-2xl font-bold border-2 border-primary-blue shadow-md">
            {testimonial.initials || testimonial.name.charAt(0).toUpperCase()}
          </div>
        )}
      </div>
      <div className="testimonial-bio text-center mt-4">
        <div className="bio-info">
          <h3 className="text-xl font-semibold text-text-gray-darkest">
            {testimonial.name}
          </h3>
          <span className="text-base text-text-gray-medium">
            {testimonial.title}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
